/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import {
  RerunCloudResourceReportInput,
  useRerunCloudResourceReportMutation,
} from "~/generated/graphql";
import { showError, showSuccess } from "~/services/toast";

type Props = {
  reportName: string;
};

export function useRerunCloudResourceReport({ reportName }: Props) {
  const [rerunCloudResourceReportMutation, { loading }] =
    useRerunCloudResourceReportMutation({
      onCompleted: (response) => {
        if (response.rerunCloudResourceReport) {
          showSuccess(
            `The generation of the report ${reportName} has started.`,
            { type: "info" }
          );
        } else {
          showError(RERUN_ERROR_MESSAGE);
        }
      },
      onError: (error) => {
        showError(`Failed to generate the report: ${error.message}`);
      },
    });

  function rerunCloudResourceReport(data: RerunCloudResourceReportInput) {
    rerunCloudResourceReportMutation({
      variables: {
        input: data,
      },
    });
  }

  return [rerunCloudResourceReport, loading] as const;
}

const RERUN_ERROR_MESSAGE = "There was an issue with generating the report.";
